import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d8ce9c0")

_pushScopeId("data-v-2d8ce9c0")
const _hoisted_1 = { class: "element-outline" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "启用边框：", -1)
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "边框样式：", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("实线边框")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("虚线边框")
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "边框颜色：", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "边框粗细：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Switch = _resolveComponent("Switch")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_Select = _resolveComponent("Select")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_ColorButton = _resolveComponent("ColorButton")
  const _component_Popover = _resolveComponent("Popover")
  const _component_InputNumber = _resolveComponent("InputNumber")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.fixed)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Switch, {
              checked: _ctx.hasOutline,
              onChange: _cache[1] || (_cache[1] = checked => _ctx.toggleOutline(checked))
            }, null, 8, ["checked"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasOutline)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Select, {
              style: {"flex":"3"},
              value: _ctx.outline.style,
              onChange: _cache[2] || (_cache[2] = value => _ctx.updateOutline({ style: value }))
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectOption, { value: "solid" }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "dashed" }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.outline.color,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = value => _ctx.updateOutline({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.outline.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_InputNumber, {
              value: _ctx.outline.width,
              onChange: _cache[4] || (_cache[4] = value => _ctx.updateOutline({ width: value })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})